export const V2_INPUT_HEIGHT_PX = 56;
export const V2_INPUT_WIDTH_PX = 312;
export const V2_ICON_MIN_SIZE = 24;
export const V2_BUTTON_SIZES = {
  large: {
    height: 56,
    paddingX: 24,
    paddingY: 16,
    iconSize: 24,
  },
  small: {
    height: 40,
    paddingX: 16,
    paddingY: 8,
    iconSize: 24,
  },
} as const;
